<template>
    <div class="row">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">Club Event Timeslots</h3>
            </div>
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Number required</th>
                        <th>Hours</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(timeslot, index) in timeslots">
                        <td>{{ timeslot.timeslot_name }}</td>
                        <td>{{ timeslot.number_required }}</td>
                        <td>{{ timeslot.hours }}</td>
                        <td>
                            <button @click="editJob(timeslot)" class="btn btn-sm btn-primary">Edit</button>
                            <button @click="removeJob(timeslot.id)" class="btn btn-sm btn-danger">Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


</template>
<script>
    export default {
        props: [
            'eventId',
            'jobId'
        ],

        data: function () {
            return {
                timeslots: []
            }
        },

        mounted() {
            this.getTimeslots();
        },

        methods: {
            getTimeslots() {
                axios.get(`/api/v1/club_events/${this.eventId}/jobs/${this.jobId}/timeslots`).then((response) => {
                    this.timeslots = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading timeslots.', type: 'error'});
                });
            },

            formatDate(theDate) {
                return moment(theDate).format("DD/MM/YYYY")
            },

            removeJob(id) {
                axios.delete(`/api/v1/club_events/${this.eventId}/jobs/${this.jobId}/timeslots/${id}`)
                    .then(response => {
                        this.getTimeslots();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem removing the job.', type: 'error'});
                    });
            },

            editJob(event) {
                this.$emit('timeslot-edit', event);
            }
        },
    }
</script>
